import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { LoadingBar } from '../app/shared/components/loading-bar/loading-bar';

@Component({
  selector: 'app-public-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, Toast, LoadingBar],
  template: `
    <app-loading-bar />
    <p-toast />
    <router-outlet />
  `
})
export class PublicApp {}
